export const DEFAULT_CURRENCY = 'USD'
export const DEFAULT_CURRENCY_SYMBOL = '$'
export const RUSSIAN_CURRENCY = 'RUB'
